/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import Swal from 'sweetalert2';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import apresentarDecimal from '../../../tools/apresentarDecimal';
import mascaraData from '../../../tools/mascaras/data';
import mascaraReal from '../../../tools/mascaras/real';
import somenteDecimal from '../../../tools/somenteDecimal';
import validaData from '../../../tools/validaData';
import DialogActions from '@material-ui/core/DialogActions';

const useStyles = makeStyles(theme => ({
    controlaTitulo: {
        fontSize: "1.5em",
    },
    botaoRodape: {
        padding: theme.spacing(1),
    },
}))

export default function FormParcelaNfe(props) {

    const { adicionarParcela,
        grid,
        parcelaNfe,
        indexParcela,
        totalNfe,
        quantidadeParcelas = 1,
        inativo
    } = props;

    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const inputLabel = useRef(null);
    const [labelWidth] = useState(0);
    const [valorSugerido, setValorSugerido] = useState();
    const [parcelasTemp, setParcelasTemp] = useState([]);
    const [codigoParcela, setCodigoParcela] = useState(parcelaNfe ? parcelaNfe.codigoParcela : 1);
    const [tipoDocumento, setTipoDocumento] = useState(parcelaNfe ? parcelaNfe.tipoDocumento : 4);
    const [tipoDocumentoErro] = useState(false);
    const [tipoDocumentoErroTexto] = useState();
    const [valor, setValor] = useState(parcelaNfe ? apresentarDecimal(parcelaNfe.valor) : valorSugerido);
    const [valorErro, setValorErro] = useState(false);
    const [valorErroTexto, setValorErroTexto] = useState();
    const [vencimento, setVencimento] = useState(parcelaNfe ? parcelaNfe.vencimento : '');
    const [vencimentoErro, setVencimentoErro] = useState(false);
    const [vencimentoErroTexto, setVencimentoErroTexto] = useState();

    //  let parcelasTemp = [];

    function adicionaParcelatemp(parcela) {
        // eslint-disable-next-line no-unused-vars
        let parcelasTempAlterar = parcelasTemp;
        setParcelasTemp(parcelasTempAlterar => [...parcelasTempAlterar, parcela]);

    }

    useEffect(() => {
        let valorRestanteAtual = 0;
        parcelasTemp.map((parcela) => {
            return valorRestanteAtual += Number(parcela.valor);
        })
        setValor((totalNfe - valorRestanteAtual) / (quantidadeParcelas - parcelasTemp.length));
        setValorSugerido((totalNfe - valorRestanteAtual) / (quantidadeParcelas - parcelasTemp.length));
        if (parcelasTemp.length == quantidadeParcelas) {
            setOpen(false);
            adicionarParcela(parcelasTemp);
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            })
            Toast.fire({
                type: 'success',
                title: 'Parcela Salva'
            })
        }
    }, [parcelasTemp])

    useEffect(() => {
        setValorSugerido(totalNfe / quantidadeParcelas);
    }, [quantidadeParcelas])

    useEffect(() => {
        if (parcelaNfe) {
            return
        }
        if (open) {
            setCodigoParcela(0);
            setTipoDocumento(1);
            setValor(totalNfe / quantidadeParcelas);
            setVencimento('');
        }
    }, [open])

    const handleOpen = (e) => {
        e.preventDefault();
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function validaCampos() {
        let camposErrados = [];

        if (valor === '') {
            setValorErro(true);
            setValorErroTexto("Por favor preencha o Valor,campo obrigatorio");
            camposErrados.push("Valor");
        } else {
            if (parseFloat(somenteDecimal(valor)) === 0) {
                setValorErro(true);
                setValorErroTexto("Por favor preencha o Valor maior que zero");
                camposErrados.push("Valor");
            } else {
                setValorErro(false);
            }
        }

        if (vencimento === '') {
            setVencimentoErro(true);
            setVencimentoErroTexto("Por favor preencha o Valor,campo obrigatorio");
            camposErrados.push("Vencimento");
        } else {
            if (!validaData(vencimento)) {
                setVencimentoErro(true);
                setVencimentoErroTexto("Data invalida, informe uma data valida");
                camposErrados.push("Vencimento");
            } else {
                let strData = vencimento;
                let partesData = strData.split("/");
                let data = new Date(partesData[2], partesData[1] - 1, partesData[0]);
                let dataTemp = new Date();
                if (data < new Date(dataTemp.getFullYear(), dataTemp.getMonth(), dataTemp.getDate())) {
                    setVencimentoErro(true);
                    setVencimentoErroTexto("Informe uma data maior ou igual a hoje");
                    camposErrados.push("Vencimento");
                } else {
                    setVencimentoErro(false);
                }
            }
        }

        if (camposErrados.length === 0) {
            return true;
        } else {
            return false;
        }
    }

    function cancelar() {
        // parcelasTemp = [];
        setOpen(false);
    }

    function salvar() {
        if (validaCampos()) {
            if (indexParcela >= 0) {
                setOpen(false);
                adicionarParcela(
                    {
                        codigoParcela,
                        tipoDocumento,
                        valor: somenteDecimal(valor),
                        vencimento
                    }, indexParcela);

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-right',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    onOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    type: 'success',
                    title: 'Parcela Salva'
                })
            } else {
                adicionaParcelatemp({
                    codigoParcela,
                    tipoDocumento,
                    valor: somenteDecimal(valor),
                    vencimento
                })
                setVencimento('');
            }
        }

    }


    return (
        <div>
            {grid ? <IconButton aria-label="alterar"
                onClick={handleOpen}
            >
                {inativo ? <VisibilityIcon /> : <EditRoundedIcon />}
            </IconButton> : <Button
                type="button"
                variant="contained"
                color="secondary"
                fullWidth
                className={classes.controlaAddParcela}
                startIcon={<AddCircleOutlineOutlinedIcon />}
                onClick={handleOpen}
                disabled={inativo}>
                Adicionar Parcela
            </Button>}

            <Dialog
                open={open}
                onClose={handleClose}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullscreen
            >
                <DialogTitle id="scroll-dialog-title">
                    <Grid container>
                        <Grid item xs={12} className={classes.botaoRodape}>
                            <Typography
                                variant="h1"
                                component="h1"
                                gutterBottom
                                align="center"
                                color="primary"
                                className={classes.controlaTitulo}
                            >
                                Parcelas
                        </Typography>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent dividers='true'>
                    <DialogContentText
                        id="scroll-dialog-description"
                        tabIndex={-1}
                    >
                        <form>
                            <FormControl
                                variant="outlined"
                                fullWidth
                                disabled={inativo}
                            >
                                <InputLabel ref={inputLabel}>
                                    Tipo Documento
                            </InputLabel>
                                <Select
                                    error={tipoDocumentoErro}
                                    helperText={tipoDocumentoErroTexto}
                                    value={tipoDocumento}
                                    onChange={e => setTipoDocumento(e.target.value)}
                                    labelWidth={labelWidth}
                                >
                                    <MenuItem value={1}>Dinheiro</MenuItem>
                                    <MenuItem value={2}>Cheque</MenuItem>
                                    <MenuItem value={3}>Cartão Crédito</MenuItem>
                                    <MenuItem value={15}>Boleto</MenuItem>
                                    <MenuItem value={99}>Outros</MenuItem>
                                </Select>
                            </FormControl>

                            <TextField
                                fullWidth
                                label="Valor"
                                error={valorErro}
                                helperText={valorErro ? valorErroTexto : ''}
                                margin="normal"
                                variant="outlined"
                                value={valor}
                                onChange={e => setValor(e.target.value)}
                                InputProps={{
                                    inputComponent: mascaraReal,
                                }}
                                disabled={inativo}
                            />

                            <TextField
                                fullWidth
                                label="Vencimento"
                                error={vencimentoErro}
                                helperText={vencimentoErro ? vencimentoErroTexto : ''}
                                margin="normal"
                                variant="outlined"
                                value={vencimento}
                                onChange={e => setVencimento(e.target.value)}
                                InputProps={{
                                    inputComponent: mascaraData,
                                }}
                                disabled={inativo}
                            />
                        </form>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid container>
                        {inativo ? <Grid item xs={12} className={classes.botaoRodape}>
                            <Button
                                variant="contained"
                                color="secondary"
                                type="button"
                                onClick={cancelar}
                                fullWidth
                            >
                                Sair
                        </Button>
                        </Grid> : <>
                            <Grid item xs={6} className={classes.botaoRodape}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    type="button"
                                    onClick={cancelar}
                                    fullWidth
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                            <Grid item xs={6} className={classes.botaoRodape}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={salvar}
                                    fullWidth
                                >
                                    Salvar
                                </Button>
                            </Grid>
                        </>}

                    </Grid>
                </DialogActions>
            </Dialog>

        </div>
    )
}
